import { createRoot, hydrateRoot } from "react-dom/client";
import TagManager from "react-gtm-module";

import Root from "containers/Root";
import { trackViewEvents } from "lib/helpers";

// initializeApp as async so that we can wait for the mock server to start when using it for debugging tests in the browser
const initializeApp = async () => {
  if (import.meta.env.DEV && import.meta.env.REACT_APP_MOCK_SERVER) {
    console.info("Starting mock server...");
    try {
      // use dynamic imports to prevent inclusion in production bundle
      const { setupDevelopmentServer } = await import(
        "__mockData__/server/development"
      );
      const server = setupDevelopmentServer();
      await server.start();
      console.info("Server started successfully");

      const { setupSeed } = await import("__mockData__/seeds");
      if (import.meta.env.REACT_APP_RUN_TEST_DATA) {
        try {
          setupSeed[import.meta.env.REACT_APP_RUN_TEST_DATA]();
        } catch (error) {
          if (!setupSeed[import.meta.env.REACT_APP_RUN_TEST_DATA]) {
            throw new Error(
              "'REACT_APP_RUN_TEST_DATA' must only reference functions registered in setupSeed ('__mockData__/seeds')",
            );
          } else {
            throw error;
          }
        }
      } else {
        setupSeed.mockSeedData();
      }
    } catch (error) {
      console.error("Failed to initialize mock server:", error);
    }
  }

  if (trackViewEvents()) {
    const tagManagerArgs = {
      gtmId: import.meta.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
    };
    TagManager.initialize(tagManagerArgs);
  }

  const rootElement = document.getElementById("root");
  if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, <Root />);
  } else {
    const root = createRoot(rootElement);
    root.render(<Root />);
  }
};

initializeApp();
